<script setup lang="ts">
import { Loader2 } from 'lucide-vue-next'

withDefaults(
  defineProps<{
    title?: string | null
    text?: string | null
    confirmButtonLabel?: string | null
    processingButtonLabel?: string | null
    cancelButtonLabel?: string | null
    outlined?: boolean
    disabled?: boolean
    isFixed?: boolean
    white?: boolean
    isOpenable?: boolean
    processing?: boolean | null
  }>(),
  {
    title: null,
    text: null,
    confirmButtonLabel: null,
    processingButtonLabel: null,
    cancelButtonLabel: null,
    outlined: false,
    disabled: false,
    isFixed: false,
    white: true,
    isOpenable: true,
    processing: null
  }
)

const emit = defineEmits<{
  (e: 'confirm'): void
}>()

const open = ref(false)

const confirmAndClose = () => {
  emit('confirm')
  open.value = false
}
</script>

<template>
  <div>
    <Button
      :variant="outlined || white ? 'outline' : 'default-primary'"
      :class="[
        'w-full',
        isFixed ? 'fixed bottom-0 left-0 z-10 w-screen rounded-none sm:static sm:w-auto sm:rounded-control' : ''
      ]"
      :disabled="disabled"
      @click="open = isOpenable"
    >
      <slot />
    </Button>

    <AlertDialog v-model:open="open">
      <AlertDialogContent class="sm:max-w-sm">
        <AlertDialogHeader>
          <div class="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
            <BaseIcon name="HeroExclamationTriangleIconOutline" class="h-6 w-6 text-green-600" aria-hidden="true" />
          </div>
          <AlertDialogTitle class="text-center">{{ title }}</AlertDialogTitle>
          <AlertDialogDescription v-if="text" class="text-center">{{ text }}</AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter class="sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
          <AlertDialogCancel class="sm:col-start-1 sm:mt-0">
            {{ cancelButtonLabel }}
          </AlertDialogCancel>
          <Button
            variant="default-primary"
            class="sm:col-start-2"
            :disabled="processing === true"
            @click="confirmAndClose"
          >
            <Loader2 v-if="processing" class="animate-spin" />
            {{ processing ? processingButtonLabel : confirmButtonLabel }}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  </div>
</template>
